/**
 * The job page tells ⌘K what this job's actions are (job page v2, slice 2).
 *
 * The new job page publishes its one job-actions list here while it is open;
 * the top bar's ⌘K palette reads it and shows a "This job" group above Do /
 * Jump to / Find. Leaving the page clears it. "More for this job" on the page
 * opens the same palette through `openCommandPalette()`.
 *
 * A tiny external store (useSyncExternalStore), not a React context: the top
 * bar sits outside the page's tree.
 */
import { useSyncExternalStore } from "react";
import type { JobAction, JobActionId } from "@/pages/jobs/detail/jobActions";

export interface JobActionsPublication {
    jobId: string;
    /** "#092678422". */
    jobLabel: string;
    actions: JobAction[];
    pins: JobActionId[];
    pinsAreOfficeDefault: boolean;
    togglePin: (id: JobActionId) => void;
    resetPins: () => void;
}

let current: JobActionsPublication | null = null;
const listeners = new Set<() => void>();

export function publishJobActions(next: JobActionsPublication | null): void {
    current = next;
    for (const l of listeners) l();
}

export function useJobActionsPublication(): JobActionsPublication | null {
    return useSyncExternalStore(
        (l) => {
            listeners.add(l);
            return () => listeners.delete(l);
        },
        () => current,
        () => null,
    );
}

export const OPEN_PALETTE_EVENT = "gwc:open-palette";

/** Open the top bar's ⌘K palette from anywhere. */
export function openCommandPalette(): void {
    window.dispatchEvent(new CustomEvent(OPEN_PALETTE_EVENT));
}
